/**
 * Role Service
 *
 * Handles role and permission operations
 */

import { BaseService } from "../base/BaseService";
import { RoleInfo, AdminVerification, AssignRoleResponse } from "./types";

const AUTH_SERVICE_URL = "auth";

/**
 * Role Service
 * Handles all role and permission-related operations
 */
export class RoleService extends BaseService {
  constructor() {
    super(AUTH_SERVICE_URL);
  }

  /**
   * Get user roles and permissions
   * GET /roles/:userId
   */
  getUserRoles(userId: string): Promise<RoleInfo> {
    return this.get(`/roles/${userId}`);
  }

  /**
   * Verify user has specific role
   * POST /roles/verify
   */
  verifyRole(userId: string, role: string): Promise<{ hasRole: boolean }> {
    return this.post("/roles/verify", { userId, role });
  }

  /**
   * Assign role to user (admin only)
   * POST /roles/assign
   */
  assignRole(adminId: string, targetUserId: string, role: string): Promise<AssignRoleResponse> {
    return this.post("/roles/assign", { adminId, targetUserId, role });
  }

  /**
   * Get user permissions
   * GET /permissions/:userId
   */
  getUserPermissions(userId: string): Promise<{ permissions: string[] }> {
    return this.get(`/permissions/${userId}`);
  }

  /**
   * Check specific permission
   * POST /permissions/check
   */
  checkPermission(userId: string, permission: string): Promise<{ hasPermission: boolean }> {
    return this.post("/permissions/check", { userId, permission });
  }

  /**
   * Verify admin status (cached for 5 minutes)
   * POST /admin/verify
   */
  verifyAdmin(userId: string): Promise<AdminVerification> {
    return this.post("/admin/verify", { userId });
  }
}
